var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.item.label)+" "),(_vm.item.reasonLabels)?_c('ul',_vm._l((_vm.item.reasonLabels),function(reason,key){return _c('li',{key:key},[_vm._v(" "+_vm._s(reason)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }